import UserRepo from '../repos/UserRepo'
import SentenceRepo from '../repos/SentenceRepo'
import CategoryRepo from '../repos/CategoryRepo'
import PageRepo from '../repos/PageRepo'
import CommentRepo from '../repos/CommentRepo'
import SchoolRepo from '../repos/SchoolRepo'
import PaddleRepo from '../repos/PaddleRepo'
import TourRepo from '../repos/TourRepo'
import LessonRepo from '../repos/LessonRepo'
import StudentRepo from '../repos/StudentRepo'
import STBYLessonRepo from '../repos/STBYLessonRepo'
import Helper from '../services/Helper'
import HelperArrays from '../services/HelperArrays'
import Vue from 'vue'

let attr1 = 0;
export default {
    data(){
        return {
            userRepo        : new UserRepo(this.$auth),
            pageRepo        : new PageRepo(this.$auth),
            sentenceRepo    : new SentenceRepo(this.$auth),
            categoryRepo    : new CategoryRepo(this.$auth),
            commentRepo     : new CommentRepo(this.$auth),
            schoolRepo      : new SchoolRepo(this.$auth),
            paddleRepo      : new PaddleRepo(this.$auth),
            lessonRepo      : new LessonRepo(this.$auth),
            studentRepo     : new StudentRepo(this.$auth),
            tourRepo        : new TourRepo(this.$auth),
            stbyLessonRepo  : new STBYLessonRepo(this.$auth),
            helper          : new Helper(),
            helperArrays    : new HelperArrays(),
            MAGIC_EARS      : {id:1, name:'Magic Ears'},
            VIPKID          : {id:3, name:'VIPKID'},
            ITUTOR          : {id:6, name:'iTutorGroup (TutorABC)'},
            BEGINNER_PLAN               : {id:527533, name:'Beginner', description: 'Billed monthly', color:'has-text-black'},
            BEGINNER_PLAN_NEW           : {id:576161, name:'Beginner', description: 'Billed monthly', color:'has-text-black'},
            EXPERIENCED_PLAN            : {id:527534, name:'Experienced', description: 'Billed every 6 months', color:'has-text-warning'},
            PROFESSIONAL_PLAN           : {id:527535, name:'Professional', description: 'Billed every 12 months', color:'has-text-primary'},
            tourActive : false,
            me : {
                price: 0,
                user: {
                    profile: {
                        name: ''
                    },
                    news : [],
                    unseenNews :[]
                },
                id: -1
            },
        }
    },
    //mixins : [tour],

    methods: {


        getStudentId(str){
            let search = str.split('?')[1];
            if( search.includes('studentId')){
                let params = str.split('&');
                let result = str;
                params.forEach(function (element) {
                    if(element.includes('studentId')){
                        result = element.split('=')[1];
                    }
                })
                return result;
            }else{
                return null;
            }

        },
        validURL(str) {
            var regexp =  /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
            return regexp.test(str);
/*
            var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
                '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
                '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
                '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
                '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
                '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
            return !!pattern.test(str);*/
        },

        getPlan(planId){
            return (planId == this.BEGINNER_PLAN.id || planId == this.BEGINNER_PLAN_NEW.id) ? (this.BEGINNER_PLAN) : ( (planId == this.EXPERIENCED_PLAN.id) ? this.EXPERIENCED_PLAN : this.PROFESSIONAL_PLAN);
        },

        isMEFullFormat(str){
            str = str.toUpperCase();
            str = str.replace(/\s+/g, '');
            if (str === "") {
                return true;
            }
            var res = str.split("-");
            if (res.length == 3) {
                var str1 = res[0];
                var str2 = res[1];
                var str3 = res[2];
                if (str1[0] !== "L" || str2[0] !== "U" || str3[0] !== "L") {
                    return true;
                }
            }
            return false;
        },

        meLessonFormat(str, fullFormat = true){
            str = str.toUpperCase();
            str = str.replace(/\s+/g, '');
            if (str === "") {
                return true;
            }
            var res = str.split("-");
            if (res.length !== 3) {
                return false;
            }
            else {
                var str1 = res[0];
                var str2 = res[1];
                var str3 = res[2];
                var ch = true;
                if(fullFormat){
                    if (str1[0] !== "L" || str2[0] !== "U" || str3[0] !== "L") {
                        if (str1.length === 0 || isNaN(str1) || str1.includes("E") || str2.length === 0 || isNaN(str2) || str2.includes("E") || str3.length === 0 || isNaN(str3) || str3.includes("E")) {
                            return false;
                        }
                        return true;
                    }
                    str1 = str1.substring(1, str1.length);
                    str2 = str2.substring(1, str2.length);
                    str3 = str3.substring(1, str3.length);
                }

                if (str1.length === 0 || isNaN(str1) || str1.includes("E") || str2.length === 0 || isNaN(str2) || str2.includes("E") || str3.length === 0 || isNaN(str3) || str3.includes("E")) {
                    return false;
                }
                return true;

            }
        },

        vkLessonFormat(str){
            str = str.toUpperCase();
            str = str.replace(/\s+/g, '');
            if (str === "") {
                return true;
            }
            var res = str.split("-");

            if (res.length === 4) {
                return this.is_trial_vipkid(res);
            }
            if (res.length === 5) {
                return this.is_mc_vipkid(res);
            }
            return false;
        },

        is_trial_vipkid(parts){
            let str = parts[0];

            if(['MSCP'].includes(str)){
                return this.is_mcsp_vipkid(parts);
            }
            if(!['T1','LT1'].includes(str)){
                return false;
            }
            let str1 = parts[1];
            let str2 = parts[2];
            let str3 = parts[3];
            if (str1.length<2 || str2.length<3 || str3.length< 2 || str1[0] !== "U" || (str2[0] !== "L" && str2[1] !== "C") || str3[0] !== "L") {
                return false;
            }
            str1 = str1.substring(1, str1.length);
            str2 = str2.substring(2, str2.length);
            str3 = str3.substring(1, str3.length);
            if (str1.length === 0 || str1.includes("E") || isNaN(str1) || str2.length === 0 || str2.includes("E") || isNaN(str2) || str3.length === 0 || str3.includes("E") || isNaN(str3)) {
                return false;
            }
            return true;
        },

        is_mcsp_vipkid(parts){
            //skip first element
            let str1 = parts[1];
            let str2 = parts[2];
            let str3 = parts[3];
            if (str1.length<2 || str2.length<2 || str3.length< 2 || str1[0] !== "L" || str2[0] !== "U" || str3[0] !== "L"){
                return false;
            }
            str1 = str1.substring(1, str1.length);
            str2 = str2.substring(1, str2.length);
            str3 = str3.substring(1, str3.length);
            if (str1.length === 0 || str1.includes("E") || isNaN(str1) || str2.length === 0 || str2.includes("E") || isNaN(str2) || str3.length === 0 || str3.includes("E") || isNaN(str3)) {
                return false;
            }
            return true;
        },

        is_mc_vipkid(parts){
            let str = parts[0];
            let str4 = parts[4];
            if(['T1'].includes(str)){
                if(str4.length !== 0 && !str4.includes("E") || !isNaN(str4)) {
                    parts.pop();
                    return this.is_trial_vipkid(parts);
                }
            }
            if(!['BK','DG','FS','ST','ES','GM','MVP01','PH','PP','FT','TP','VV','W3','W2','W1','LT1','ME','MCS','MC','T1','IMC'].includes(str)){
                return false;
            }
            let str1 = parts[1];
            let str2 = parts[2];
            let str3 = parts[3];
            if (str1.length<2 || str2.length<2 || str3.length< 3 || str1[0] !== "L" || str2[0] !== "U" || (str3[0] !== "L" && str3[1] !== "C")) {
                return false;
            }
            str1 = str1.substring(1, str1.length);
            str2 = str2.substring(1, str2.length);
            str3 = str3.substring(2, str3.length);
            if (str1.length === 0 || str1.includes("E") || isNaN(str1)||
                str2.length === 0 || str2.includes("E") || isNaN(str2) ||
                str3.length === 0 || str3.includes("E") || isNaN(str3)||
                str4.length === 0 || str4.includes("E") || isNaN(str4)) {
                return false;
            }
            return true;
        },

        makeLink(text){
            return (text || "").replace(
                /([^\S]|^)(((https?\:\/\/)|(www\.))(\S+))/gi,
                function(match, space, url){
                    var hyperlink = url;
                    if (!hyperlink.match('^https?:\/\/')) {
                        hyperlink = 'http://' + hyperlink;
                    }
                    return space + '<a target="_blank" href="' + hyperlink + '">' + url + '</a>';
                }
            );
        },

        meDefaultAdditionalInfo(){
            return {
                crown_page: "",
                ending_song_length: "",
                game: "",
                id: "",
                name: "",
                other_key_words: "",
                practice_words: "",
                prop_ideas: "",
                provider_full_id: "",
                provider_id: "",
                role_play_slides: "",
                sentences: "",
                show_time: "",
                words: "",
            };
        },

        vkDefaultAdditionalInfo(){
            return {
                assessment: '',
                connected_speach: '',
                digital_rewards: '',
                discussion_questions: '',
                goals: '',
                google_slides: '',
                grammar: '',
                id: '',
                intonation: '',
                listening: '',
                materials: '',
                math: '',
                name: '',
                notes: '',
                noun: '',
                objective: '',
                outline: '',
                phonics: '',
                phonics_reader: '',
                project_options: '',
                props: '',
                provider_full_id: '',
                reading: '',
                reading_comp: '',
                reward_system: '',
                sentence_pattern: '',
                sight_words: '',
                social_science: '',
                sounds: '',
                tips_tricks: '',
                verb: '',
                vocabulary_strategies: '',
                words: '',
            };
        },

        restDefaultAdditionalInfo(){
            return {
                grammar: '',
                id: '',
                math: '',
                name: '',
                objective: '',
                phonics: '',
                project_options: '',
                provider_full_id: '',
                sentence_pattern: '',
                sight_words: '',
                social_science: '',
                words: '',
            };
        },

        startTour(){
            this.tourActive = true;
        },
        nextPage(path){
            this.$router.push(path);
        },
        skipTour(){
            this.tourActive = false;
        },
        nextStep(currentStep){
            if(currentStep == 2){
                this.step = 1;
            }
        },
        prevStep(currentStep){
            if(currentStep == 1){
                this.step = 2;
            }
        },
        onChangeStep(currentStep){
            if(currentStep <= 1){
                this.step = 2;
            }
            else if(currentStep >= 2){
                this.step = 1;
            }
        },
        loadTour(){
            this.tourRepo.get({route : this.$route.path}).then(response => {
                if(response.data.data.show) {
                    this.tourActive = true;
                }
            });
        },
    },


};



// WEBPACK FOOTER //
// ./src/mixins/globalMixins.js